import { AxiosResponse } from 'axios';
import { http, ServerType } from '../http';
// request model
import { IUserManagementSearchModel,
    IUserManagementSearchRequestModel,
    IUserManagementAddUsersRequestModel,
    IUserManagementeSendWelcomeEmailrRequestModel,
    IUserManagementeUpdateUserRequestModel,
    IAllRolesModel,
    IUserManagementeDeleteUserRequestModel,
    ITemplateSearchRequestModel,
    ITemplateResModel,
    IGetCorpsSprayReqModel,
    ITemplateOptionsResModel,
    ITimezoneListResModel,
    addTemplateResModel,
    getLocationByNameOrCoordinateResModel,
    getTemplateDetailResModel,
    saveTemplateReqModel,
    deleteTemplateReqModel,
    IGetHistoricalOrForecastDataReqModel,
    IgetAllBannersResModel,
    IUploadModel,
    IFileContent,
    ISubscriptionsRequestModel,
    ItransferTemplatesToUserRequestModel,
    ICopyTemplateModel,
    addSubscriptionResModel,
    saveSubscriptionReqModel,
    deleteSubscriptionReqModel,
    ISubscriptionResModel,
    getSubscriptionDetailResModel,
    IUploadBannersModel,
    IAgriAlertTranslateReqModel,
    IGetHistoricalDataReqModel,
    IGetForecastDataReqModel,
    IGetPlantingReqModel,
    IGetDiseaseRiskReqModel,
    IGetStressAlertReqModel,
    IUpdateReportNextSendTimeReq,
    IGetPhytophagyStressReqModel
} from './requestType';
// response model
import { IAgriAlertTranslateResModel,
    IGetCorpsSprayResModel,
    IGetDiseaseRiskDataResModel,
    IGetHistoricalOrForecastDataResModel,
    IGetPhytophagyStressRiskDataResModel,
    IGetPlantingdDataResModel,
    IGetStressAlertDataResModel,
    IGetStressAlertResModel
} from './responseType';

const getUserList = async (data: {
    searchText?: string
    pageIndex?: number
    pageSize?:number
    isGetAllUsers?: boolean
    isSortByNameDesc?:boolean
    module:string
}) => {
    const url = 'api/User/GetUserList';
    const response = await http.post<
        IUserManagementSearchRequestModel, AxiosResponse<IUserManagementSearchModel[]>>(
            url,
            data,
            ServerType.ServerNormal
        );
    return response.data;
};
const searchUserInformation = async (searchText: string) => {
    const url = '/api/User/GetAzureUsersInfo';
    const response = await http.post<
        { searchText: string },
        AxiosResponse<any>
    >(url, { searchText }, ServerType.ServerNormal);
    return response.data;
};
const getAgriAlertAdminPublisherUsers = async () => {
    const url = '/api/User/GetAgriAlertAdminPublisherUsers';
    const response = await http.get<null, AxiosResponse<any>>(url, null, ServerType.ServerNormal);
    return response;
};
const addUsers = async (data: IUserManagementAddUsersRequestModel) => {
    const url = 'api/User/AddUser';
    const response = await http.post<
        IUserManagementAddUsersRequestModel, AxiosResponse<any>>(
            url,
            data,
            ServerType.ServerNormal,
        );
    return response.data;
};
const sendWelcomeEmail = async (data: IUserManagementeSendWelcomeEmailrRequestModel) => {
    const url = 'api/User/SendWelcomeEmail';
    const response = await http.post<
        IUserManagementeSendWelcomeEmailrRequestModel, AxiosResponse<any>>(
            url,
            data,
            ServerType.ServerNormal,
        );
    return response.data;
};
const updateUser = async (data: IUserManagementeUpdateUserRequestModel) => {
    const url = 'api/User/UpdateUser';
    const response = await http.post<
        IUserManagementeUpdateUserRequestModel, AxiosResponse<any>>(
            url,
            data,
            ServerType.ServerNormal,
        );
    return response.data;
};
const userManagementGetCurrentUserInfo = async (module:string) => {
    const url = 'api/User/GetCurrentUserInfo?module=' + module;
    const response = await http.get<null, AxiosResponse<{ userIsActive: boolean }>>(url, null, ServerType.ServerNormal);
    return response;
};
const getAllRoles = async (module:string) => {
    const url = '/api/User/GetAllRoles?module=' + module;
    const response = await http.get<null, AxiosResponse<IAllRolesModel>>(url, null, ServerType.ServerNormal);
    return response.data;
};
const deleteAgriAlertUsers = async (data: IUserManagementeDeleteUserRequestModel) => {
    const url = 'api/User/DeleteAgriAlertUsers';
    const response = await http.post<
    IUserManagementeDeleteUserRequestModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal,
    );
    return response.data;
};
const checkIfUserHaveTemplate = async (userId:string) => {
    const url = '/api/AgriAlertTemplate/CheckIfUserHaveTemplate?userId='+userId;
    const response = await http.get<null, AxiosResponse<any>>(url, null, ServerType.ServerNormal);
    return response.data;
};
const transferTemplatesToUser = async (data: ItransferTemplatesToUserRequestModel) => {
    const url = 'api/AgriAlertTemplate/TransferTemplatesToUser';
    const response = await http.post<
    ItransferTemplatesToUserRequestModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal,
    );
    return response.data;
};
//template
const getAllTemplates = async (data: ITemplateSearchRequestModel) => {
    const url = 'api/AgriAlertTemplate/GetAllTemplates';
    const response = await http.post<
    ITemplateSearchRequestModel, AxiosResponse<ITemplateResModel[]>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const getMyTemplates = async (data: ITemplateSearchRequestModel) => {
    const url = 'api/AgriAlertTemplate/GetMyTemplates';
    const response = await http.post<
    ITemplateSearchRequestModel, AxiosResponse<ITemplateResModel[]>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const agriAlertGetCurrentUser = async (module:string) => {
    const url = 'api/User/GetCurrentUserInfo?module=' + module;
    const response = await http.get<null, AxiosResponse<IUserManagementSearchModel>>(url, null, ServerType.ServerNormal);
    return response;
};
const getTemplateOptions = async () => {
    const url = 'api/AgriAlertTemplate/GetTemplateOptions';
    const response = await http.get<null, AxiosResponse<ITemplateOptionsResModel>>(url, null, ServerType.ServerNormal);
    return response;
};
const getTimezoneList = async () => {
    const url = 'api/AgriAlertTemplate/GetTimezoneList';
    const response = await http.get<null, AxiosResponse<ITimezoneListResModel[]>>(url, null, ServerType.ServerNormal);
    return response;
};
const addTemplate = async (data: addTemplateResModel) => {
    const url = '/api/AgriAlertTemplate/AddTemplate';
    const response = await http.post<
    addTemplateResModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const getLocationByNameOrCoordinate = async (searchText:string) => {
    const url = 'api/AgriAlertTemplate/GetLocationByNameOrCoordinate?searchText='+searchText;
    const response = await http.get<null, AxiosResponse<getLocationByNameOrCoordinateResModel[]>>(url, null, ServerType.ServerNormal);
    return response;
};
const getTemplateDetail = async (templateId:number) => {
    const url = 'api/AgriAlertTemplate/GetTemplateDetail?templateId='+templateId;
    const response = await http.get<null, AxiosResponse<getTemplateDetailResModel>>(url, null, ServerType.ServerNormal);
    return response;
};
const saveTemplate = async (data: saveTemplateReqModel) => {
    const url = '/api/AgriAlertTemplate/SaveTemplate';
    const response = await http.post<
    saveTemplateReqModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const deleteTemplate = async (data:deleteTemplateReqModel) => {
    const url = 'api/AgriAlertTemplate/DeleteTemplate';
    const response = await http.post<
    deleteTemplateReqModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const getAllBanners = async () => {
    const url = 'api/AgriAlertTemplate/GetAllBanners';
    const response = await http.get<null, AxiosResponse<IgetAllBannersResModel[]>>(url, null, ServerType.ServerNormal);
    return response;
};
const checkIsValidTempOrSubName = async (name:string) => {
    const url = 'api/AgriAlertTemplate/CheckIsValidTempOrSubName?name='+name;
    const response = await http.get<null, AxiosResponse<any>>(url, null, ServerType.ServerNormal);
    return response;
};
const uploadReportBanner = async (data:IFileContent[]) => {
    const url = 'api/AgriAlertTemplate/UploadReportBanner';
    const response = await http.post<
    IFileContent[], AxiosResponse<IUploadBannersModel>>(
        url,
        data,
        ServerType.ServerNormal,
        false,
        true
    );
    return response.data;
};
const copyTemplate = async (data:ICopyTemplateModel) => {
    const url = 'api/AgriAlertTemplate/CopyTemplate';
    const response = await http.post<
    ICopyTemplateModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};

// for preview
const agriAlertGetPhytophagyStressData = async (data: IGetPhytophagyStressReqModel) => {
    const url = '/api/AgriAlertReport/GetPhytophagyStressRiskData';
    const res = await http.post<IGetPhytophagyStressReqModel, AxiosResponse<IGetPhytophagyStressRiskDataResModel[]>>(url,
        data,
        ServerType.ServerNormal);
    return res;
};
const agriAlertGetPhytophagyForstRiskData = async (data: IGetPhytophagyStressReqModel) => {
    const url = '/api/AgriAlertReport/GetPhytophagyFrostRiskData';
    const res = await http.post<IGetPhytophagyStressReqModel, AxiosResponse<IGetPhytophagyStressRiskDataResModel[]>>(url,
        data,
        ServerType.ServerNormal);
    return res;
};
const agriAlertGetStressAlertData = async (data: IGetStressAlertReqModel) => {
    const url = '/api/AgriAlertReport/GetStressAlertData';
    const res = await http.post<IGetStressAlertReqModel, AxiosResponse<IGetStressAlertDataResModel[]>>(url,
        data,
        ServerType.ServerNormal);
    return res;
};
const agriAlertGetDiseaseRiskData = async (data: IGetDiseaseRiskReqModel) => {
    const url = '/api/AgriAlertReport/GetDiseaseRiskData';
    const res = await http.post<IGetDiseaseRiskReqModel, AxiosResponse<IGetDiseaseRiskDataResModel[]>>(url,
        data,
        ServerType.ServerNormal);
    return res;
};
const agriAlertGetPlantingData = async (data: IGetPlantingReqModel) => {
    const url = '/api/AgriAlertReport/GetPlantingWindowData';
    const res = await http.post<IGetPlantingReqModel, AxiosResponse<IGetPlantingdDataResModel[]>>(url,
        data,
        ServerType.ServerNormal);
    return res;
};
const agriAlertGetCropsSpray = async (data: IGetCorpsSprayReqModel) => {
    const url = '/api/AgriAlertTemplate/GetSprayWindowRecommendation';
    const res = await http.get<IGetCorpsSprayReqModel, AxiosResponse<IGetCorpsSprayResModel>>(url,
        data,
        ServerType.ServerNormal);
    return res;
};
const agriAlertGetHistoricalOrForecastData = async(data: IGetHistoricalOrForecastDataReqModel)=>{
    const url = '/api/AgriAlertReport/GetHistoricalOrForecastData';
    const res = await http.post<IGetHistoricalOrForecastDataReqModel, AxiosResponse<IGetHistoricalOrForecastDataResModel[]>>(
        url,
        data, ServerType.ServerNormal);
    return res;

};
const agriAlertGetForecastData = async(data: IGetForecastDataReqModel)=>{
    const url = '/api/AgriAlertReport/GetForecastData';
    const res = await http.post<IGetForecastDataReqModel, AxiosResponse<IGetHistoricalOrForecastDataResModel[]>>(
        url,
        data,
        ServerType.ServerNormal
        // ServerType.ServerUser
    );
    return res;

};
const agriAlertGetForecast8HourlyData = async(data: IGetForecastDataReqModel)=>{
    const url = '/api/AgriAlertReport/GetForecast8HourlyData';
    const res = await http.post<IGetForecastDataReqModel, AxiosResponse<IGetHistoricalOrForecastDataResModel[]>>(
        url,
        data,
        ServerType.ServerNormal
        // ServerType.ServerUser
    );
    return res;

};
const agriAlertGetForecastHourlyData = async(data: IGetForecastDataReqModel)=>{
    const url = '/api/AgriAlertReport/GetForecastHourlyData';
    const res = await http.post<IGetForecastDataReqModel, AxiosResponse<IGetHistoricalOrForecastDataResModel[]>>(
        url,
        data,
        ServerType.ServerNormal
        // ServerType.ServerUser
    );
    return res;

};
const agriAlertGetHistoricalData = async(data: IGetHistoricalDataReqModel)=>{
    const url = '/api/AgriAlertReport/GetHistoricaltData';
    const res = await http.post<IGetHistoricalOrForecastDataReqModel, AxiosResponse<IGetHistoricalOrForecastDataResModel[]>>(
        url,
        data,
        // ServerType.ServerUser
        ServerType.ServerNormal
    );
    return res;

};
//Subscriptions
const getActiveSubscriptions = async (data: ISubscriptionsRequestModel) => {
    const url = 'api/AgriAlertTemplate/GetActiveSubscriptions';
    const response = await http.post<
    ISubscriptionsRequestModel, AxiosResponse<ISubscriptionResModel[]>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const getMySubscriptions = async (data: ISubscriptionsRequestModel) => {
    const url = 'api/AgriAlertTemplate/GetMySubscriptions';
    const response = await http.post<
    ISubscriptionsRequestModel, AxiosResponse<ISubscriptionResModel[]>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const addSubscription = async (data: addSubscriptionResModel) => {
    const url = '/api/AgriAlertTemplate/AddSubscription';
    const response = await http.post<
    addSubscriptionResModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const saveSubscription = async (data: saveSubscriptionReqModel) => {
    const url = '/api/AgriAlertTemplate/SaveSubscription';
    const response = await http.post<
    saveSubscriptionReqModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const checkIfUserHaveSubscription = async (userId:string) => {
    const url = '/api/AgriAlertTemplate/CheckIfUserHaveSubscription?userId='+userId;
    const response = await http.get<null, AxiosResponse<any>>(url, null, ServerType.ServerNormal);
    return response.data;
};
const getSubscriptionDetail = async (subscriptionId:number) => {
    const url = 'api/AgriAlertTemplate/GetSubscriptionDetail?subscriptionId='+subscriptionId ;
    const response = await http.get<null, AxiosResponse<getSubscriptionDetailResModel>>(url, null, ServerType.ServerNormal);
    return response;
};
const deleteSubscription = async (data:deleteSubscriptionReqModel) => {
    const url = 'api/AgriAlertTemplate/DeleteSubscription';
    const response = await http.post<
    deleteSubscriptionReqModel, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const updateReportNextSendTime = async (data:IUpdateReportNextSendTimeReq) => {
    const url = 'api/AgriAlertTemplate/UpdateReportNextSendTime';
    const response = await http.post<
    IUpdateReportNextSendTimeReq, AxiosResponse<any>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};
const getAgriAlertTranslateValue = async (languageCode:string) => {
    const url = '/api/AgriAlertReport/GetAgriAlertTranslateValues';
    const response = await http.post<
    IAgriAlertTranslateReqModel, AxiosResponse<IAgriAlertTranslateResModel>>(
        url,
        {
            languageCode: languageCode
        },
        ServerType.ServerNormal
    );
    return response.data;
};
export {
    getUserList,
    searchUserInformation,
    addUsers,
    sendWelcomeEmail,
    updateUser,
    userManagementGetCurrentUserInfo,
    getAllRoles,
    deleteAgriAlertUsers,
    getAllTemplates,
    getMyTemplates,
    agriAlertGetCurrentUser,
    agriAlertGetCropsSpray,
    getTemplateOptions,
    getTimezoneList,
    addTemplate,
    getLocationByNameOrCoordinate,
    getTemplateDetail,
    saveTemplate,
    deleteTemplate,
    agriAlertGetHistoricalOrForecastData,
    agriAlertGetForecast8HourlyData,
    agriAlertGetHistoricalData,
    agriAlertGetForecastData,
    agriAlertGetForecastHourlyData,
    getAllBanners,
    checkIsValidTempOrSubName,
    uploadReportBanner,
    getActiveSubscriptions,
    getMySubscriptions,
    checkIfUserHaveTemplate,
    transferTemplatesToUser,
    getAgriAlertAdminPublisherUsers,
    copyTemplate,
    addSubscription,
    saveSubscription,
    getSubscriptionDetail,
    deleteSubscription,
    checkIfUserHaveSubscription,
    updateReportNextSendTime,
    getAgriAlertTranslateValue,
    agriAlertGetPlantingData,
    agriAlertGetDiseaseRiskData,
    agriAlertGetStressAlertData,
    agriAlertGetPhytophagyStressData,
    agriAlertGetPhytophagyForstRiskData
};